import { useLayoutEffect } from 'react';

/**
 * Markiert die Seite als Overlay.
 *
 * Daran hängt im Stylesheet der durchsichtige Hintergrund – bis hinauf zum `html`-Element, denn
 * sonst liegt in OBS ein dunkler Kasten über dem Bild. Beim Verlassen wird die Markierung wieder
 * entfernt, damit die normalen Seiten ihren Hintergrund behalten.
 */
export function useOverlaySeite(): void {
  useLayoutEffect(() => {
    document.documentElement.dataset.overlay = 'true';
    return () => {
      delete document.documentElement.dataset.overlay;
    };
  }, []);
}
